module.exports = __webpack_public_path__ + "img/progress_088.ad039600.png";